import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

/**
 * SLT-code → qualifier-tag catalog. Backed by
 * `GET /api/v1/lab-investigations/subtest-tags`, which returns rows of
 * `{sltCode, tags:[]}`. Only a handful of sub-tests carry multi-reading
 * semantics (e.g. Morning / Evening BP, PP1 / PP2 / PP3 blood sugar) —
 * the SubTestCard reveals its Tag dropdown only when the picked
 * sub-test's sltCode has an entry here.
 *
 * Module-level cache: first call fetches; every subsequent call short-
 * circuits to the cached map. Failure degrades to an empty map so the
 * card just never shows the Tag dropdown.
 */

let CACHE = null;   // Map<sltCode, string[]>
let INFLIGHT = null;

export const getCachedSubtestTags = () => CACHE;

export const getTagsForSltCode = (sltCode) => {
  if (!CACHE || !sltCode) return [];
  return CACHE.get(String(sltCode)) || [];
};

export const fetchSubtestTags = () => {
  if (CACHE) return Promise.resolve(CACHE);
  if (INFLIGHT) return INFLIGHT;
  INFLIGHT = new Promise((resolve) => {
    const svc = new APIService();
    svc.get(
      APIConfig.labInvestigationV2.subtestTags,
      (res) => {
        const rows = Array.isArray(res)
          ? res
          : (res && Array.isArray(res.data) ? res.data : []);
        const map = new Map();
        rows.forEach((r) => {
          const code = String((r && r.sltCode) || "").trim();
          const tags = Array.isArray(r && r.tags)
            ? r.tags.map((t) => String(t || "").trim()).filter(Boolean)
            : [];
          if (code && tags.length) map.set(code, tags);
        });
        CACHE = map;
        INFLIGHT = null;
        resolve(map);
      },
      () => {
        CACHE = new Map();
        INFLIGHT = null;
        resolve(CACHE);
      },
    );
  });
  return INFLIGHT;
};
